module.exports = __webpack_public_path__ + "img/area-part3-121.078f8704.png";